/**
 * @desc 获取报告
 */
const URL = "/rantion-plat-data-flow";
import http, { updateResponse } from "@/http";
export function request(body: Array<string>, options?: any) {
  return updateResponse(
    http(URL + `/mqPush/pushMqByIds`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
